import type { IExtractRouteParamMap, IRouteTranslation } from "../../../types";
import { createPaths, createBreadcrumbObject, rebase } from "../../../utils";

// Base route constant
const baseRoute = `/faculties`;

// * Route configuration object for faculty-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const facultyRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:facultyId`,
  edit: `${baseRoute}/edit/:facultyId`,
} as const;

// ! these are breadcrumbs translation not page title
const facultyRouteTranslation: IRouteTranslation<typeof facultyRoutesObj> = {
  list: "facultiesList",
  create: "addFaculty",
  edit: "editFaculty",
  view: "viewFaculty",
};

// * Extracts the route parameters for the faculty route configuration.
export type IFacultyRouteParams = IExtractRouteParamMap<
  typeof facultyRoutesObj
>;

// * Path functions for the faculty routes.
export const facultyPath = createPaths<
  typeof facultyRoutesObj,
  IFacultyRouteParams
>(facultyRoutesObj);

// * Breadcrumbs {translation and route} for the faculty routes
export const facultyBreadcrumbs = createBreadcrumbObject<
  typeof facultyRoutesObj
>(facultyRoutesObj, facultyRouteTranslation);
rebase(facultyBreadcrumbs, "list");
